import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { CheckCircle, Warning, InstagramLogo, Share } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";

const EducationVerifyPage = () => {
  const [status, setStatus] = useState("loading");
  const [firstName, setFirstName] = useState("");
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    document.title = "Bestätigung – JS Blond Education Hub";
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      return;
    }
    fetch(`${API_URL}/api/education/verify/${token}`)
      .then(r => r.json())
      .then(data => {
        if (data.verified || data.already_verified) {
          setStatus("verified");
          setFirstName(data.first_name || "");
        } else {
          setStatus("error");
        }
      })
      .catch(() => setStatus("error"));
  }, [API_URL]);

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({ title: "JS Blond Education Hub", url: "https://js-blondsalon.de/education" });
    } else {
      navigator.clipboard.writeText("https://js-blondsalon.de/education");
    }
  };

  return (
    <div className="min-h-screen bg-[#0a0a0a]">
      <Navigation />

      <section className="pt-32 pb-20 min-h-screen flex items-center justify-center">
        <div className="max-w-lg mx-auto px-6 text-center">
          {status === "loading" && (
            <p className="text-white/50 text-sm">Wird bestätigt...</p>
          )}

          {status === "verified" && (
            <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }}>
              <CheckCircle size={56} className="text-[#D4AF37] mx-auto mb-6" weight="fill" />
              <h1 className="text-3xl sm:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                WELCOME TO<br /><span className="text-[#D4AF37]">THE COMMUNITY.</span>
              </h1>
              <p className="text-white/60 text-sm sm:text-base mb-10 max-w-md mx-auto">
                {firstName ? `Hey ${firstName}, du` : "Du"} bist dabei! Wir halten dich über unsere kommenden 
                Veranstaltungen und den Education-Kalender 2027 auf dem Laufenden.
              </p>

              {/* Bring your team */}
              <div className="bg-[#1a1a1a] border border-white/10 p-8 mb-8">
                <p className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] mb-3">Bring your Team.</p>
                <p className="text-white/50 text-sm mb-6">
                  Kennst du jemanden, der ebenfalls Teil unserer Community werden sollte? Teile unsere Seite mit deinen Kollegen.
                </p>
                <button
                  onClick={handleShare}
                  data-testid="verify-share-btn"
                  className="inline-flex items-center gap-2 px-8 py-3 border border-white/30 text-white text-xs uppercase tracking-[0.2em] font-bold hover:bg-white/10 transition-colors"
                >
                  <Share size={16} />
                  Seite teilen
                </button>
              </div>

              {/* Instagram */}
              <div className="bg-[#1a1a1a] border border-white/10 p-8">
                <p className="text-[#D4AF37] text-xs uppercase tracking-[0.3em] mb-3">Stay Connected.</p>
                <p className="text-white/50 text-sm mb-6">
                  Folge uns auf Instagram für erste Einblicke, neue Artists und kommende Veranstaltungen.
                </p>
                <a
                  href="https://www.instagram.com/jennifervallentin"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 px-8 py-3 bg-[#D4AF37] text-[#0a0a0a] text-xs uppercase tracking-[0.2em] font-bold hover:bg-white transition-colors"
                >
                  <InstagramLogo size={18} weight="fill" />
                  Follow us on Instagram
                </a>
              </div>
            </motion.div>
          )}

          {status === "error" && (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <Warning size={48} className="text-red-400 mx-auto mb-6" />
              <h1 className="text-2xl font-bold text-white mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
                Link ungültig oder abgelaufen
              </h1>
              <p className="text-white/50 text-sm mb-8">
                Bitte melde dich erneut an.
              </p>
              <Link
                to="/education"
                className="px-8 py-3 bg-[#D4AF37] text-[#0a0a0a] text-xs uppercase tracking-[0.2em] font-bold hover:bg-white transition-colors"
              >
                Zur Education-Seite
              </Link>
            </motion.div>
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default EducationVerifyPage;
